import { TableStructure } from "../components/TableStructure";
import { CitizenCharterLeftMenuList } from "../utils/constants";

const List = [
  {
    fileStoreId: "18020726-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Amusement Department",
  },
  {
    fileStoreId: "18020826-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Assessment Department",
  },
  {
    fileStoreId: "18020926-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Building Department",
  },
  {
    fileStoreId: "18021026-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter C.M.E(Civil) Department",
  },
  {
    fileStoreId: "18021126-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Education Department",
  },
  {
    fileStoreId: "18021226-2a59-4f3c-8a94-891f18042026",
    label:
      "Citizen's Charter Estate Management Department (Chief Valuer & Surveyor Deptt.)",
  },
  {
    fileStoreId: "18021326-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Health Department",
  },
  {
    fileStoreId: "18021426-2a59-4f3c-8a94-891f18042026",
    label:
      "Citizen's Charter KEIIP (Kolkata Environmental Improvement Investment Programme)",
  },
  {
    fileStoreId: "18021526-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter License Department",
  },
  {
    fileStoreId: "18021626-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Lighting Department",
  },
  {
    fileStoreId: "18021726-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Market Department",
  },
  {
    fileStoreId: "18021826-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Parking Department",
  },
  {
    fileStoreId: "18021926-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Roads Department",
  },
  {
    fileStoreId: "18022026-2a59-4f3c-8a94-891f18042026",
    label:
      "Citizen's Charter Service Records and Accounts Cell (Pension, P. F., H. B. L. & Staff Quarter) Department",
  },
  {
    fileStoreId: "18022126-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Sewerage & Drainage Department",
  },
  {
    fileStoreId: "18022226-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Solid Waste Management Department",
  },
  {
    fileStoreId: "18022326-2a59-4f3c-8a94-891f18042026",
    label: "Citizen's Charter Water Supply Department",
  },
];

const Citizen_charter_Home = () => (
  <TableStructure
    title="Citizen's Charter"
    heading={"List of Citizen's Charter"}
    list={List}
    columnNo={1}
    leftMenuList={CitizenCharterLeftMenuList}
    longMenuList={false}
  />
);

export default Citizen_charter_Home;
